import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { createQuestion } from 'funnel/actions/question';
import QuestionForm from 'funnel/components/QuestionForm';

const mapDispatchToProps = dispatch => ({
  createQuestion: fields => dispatch(createQuestion(fields)),
});
const CreateQuestionPage = ({ createQuestion }) => (
  <div className="ui clearing segment">
    <QuestionForm onSubmit={createQuestion} />
  </div>
);

CreateQuestionPage.propTypes = {
  createQuestion: PropTypes.func.isRequired,
};

export default connect(state => state, mapDispatchToProps)(CreateQuestionPage);



// WEBPACK FOOTER //
// ./src/modules/funnel/pages/CreateQuestionPage.js